import {AbstractModel} from '../abstract-model';
import {AdvertisingPlatform} from '../advertising-platform';
import {AdvertisingPlatformInfo} from '../advertising-platform-info';

export class PartnerAdvertisingPlatform extends AbstractModel {
  id: number | null = null;
  partnerId: number | null = null;
  advertisingPlatformId: number | null = null;
  currencyId: number | null = null;
  authenticationInfo: AdvertisingPlatformInfo | null = null;

  isPlatform(advertisingPlatform: AdvertisingPlatform | null): boolean {
    return this.advertisingPlatformId === advertisingPlatform?.id;
  }
}
